import axios from 'axios';

import type { Label as LabelDto } from './dto';
import { mapLabelDtoToModel } from './mapper';
import type { Label as LabelModel, LabelType } from './model';

type SiteId = string;

// NOTE: we always want to use secure API, even when the player is loaded over HTTP. Axios automatically sets the
// protocol to https for us.
const API_ROOT = `/api/v1/sites`;

export interface GetAllLabelResponse {
  items: Array<LabelDto>;
}

function createEndpointPath(siteId: SiteId): string {
  return `${API_ROOT}/${siteId}/labels`;
}

export async function getAll(siteId: SiteId, type?: LabelType): Promise<Array<LabelModel>> {
  const path = createEndpointPath(siteId);

  const response = await axios.get<GetAllLabelResponse>(`${path}${type ? `?type=${type}` : ''}`);
  return response.data.items.map(mapLabelDtoToModel);
}

export async function addCustomLabel(siteId: number, name: string): Promise<LabelModel> {
  const path = `${createEndpointPath(siteId.toString(10))}/add`;
  // eslint-disable-next-line camelcase
  const response = await axios.post<LabelModel>(path, {
    name,
  });

  return response.data;
}

export const AVAILABLE_LABELS_QUERY_KEY = 'labels-all';
